import { useEffect, useRef, useState } from "react";
import FilterListRoundedIcon from "@mui/icons-material/FilterListRounded";
import SortRoundedIcon from "@mui/icons-material/SortRounded";
import ArrowUpwardRoundedIcon from "@mui/icons-material/ArrowUpwardRounded";
import ArrowDownwardRoundedIcon from "@mui/icons-material/ArrowDownwardRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import "./ListControls.css";

const ListControls = ({
  sortOptions,
  sortBy,
  sortOrder,
  onSortByChange,
  onSortOrderChange,
  activeFilterCount = 0,
  onClearFilters,
  children,
}) => {
  const [openPanel, setOpenPanel] = useState(null);
  const rootRef = useRef(null);

  useEffect(() => {
    const close = (event) => {
      if (!rootRef.current?.contains(event.target)) setOpenPanel(null);
    };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, []);

  const currentSort = sortOptions.find((option) => option.value === sortBy);

  return (
    <div className="list_controls" ref={rootRef}>
      <div className="list_control_wrap">
        <button
          type="button"
          className={`list_control_button ${openPanel === "sort" ? "active" : ""}`}
          onClick={() => setOpenPanel(openPanel === "sort" ? null : "sort")}
        >
          <SortRoundedIcon />
          <span>Sort: {currentSort?.label || "Default"}</span>
          {sortOrder === "asc" ? <ArrowUpwardRoundedIcon /> : <ArrowDownwardRoundedIcon />}
        </button>
        {openPanel === "sort" && (
          <div className="list_control_popover sort_popover">
            <p className="list_control_title">Sort results</p>
            <div className="sort_option_list">
              {sortOptions.map((option) => (
                <button
                  type="button"
                  key={option.value}
                  className={sortBy === option.value ? "selected" : ""}
                  onClick={() => onSortByChange(option.value)}
                >
                  {option.label}
                </button>
              ))}
            </div>
            <div className="sort_direction">
              <button type="button" className={sortOrder === "asc" ? "selected" : ""} onClick={() => onSortOrderChange("asc")}>
                <ArrowUpwardRoundedIcon /> Ascending
              </button>
              <button type="button" className={sortOrder === "desc" ? "selected" : ""} onClick={() => onSortOrderChange("desc")}>
                <ArrowDownwardRoundedIcon /> Descending
              </button>
            </div>
          </div>
        )}
      </div>

      {children && (
        <div className="list_control_wrap">
          <button
            type="button"
            className={`list_control_button ${openPanel === "filter" || activeFilterCount ? "active" : ""}`}
            onClick={() => setOpenPanel(openPanel === "filter" ? null : "filter")}
          >
            <FilterListRoundedIcon />
            <span>Filters</span>
            {activeFilterCount > 0 && <span className="filter_count">{activeFilterCount}</span>}
          </button>
          {openPanel === "filter" && (
            <div className="list_control_popover filter_popover">
              <div className="filter_popover_head">
                <p className="list_control_title">Filter results</p>
                <button type="button" aria-label="Close filters" onClick={() => setOpenPanel(null)}><CloseRoundedIcon /></button>
              </div>
              <div className="filter_popover_body">{children}</div>
              {activeFilterCount > 0 && (
                <button type="button" className="clear_filter_button" onClick={onClearFilters}>Clear all filters</button>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ListControls;
